import { db } from '@/api/firebase';
import { useToast } from '@/components/ui/use-toast';
import { deleteDoc, doc } from 'firebase/firestore';
import { useState } from 'react';
import { useLogs } from './useLogs';

const useDelete = (id, collection, fetch, where) => {
  const { addLog } = useLogs();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { toast } = useToast();

  const deleteItem = async () => {
    try {
      setLoading(true);
      const docRef = doc(db, collection, id);
      await deleteDoc(docRef);
      toast({
        title: "Muvaffaqiyatli o'chirildi",
      });

      addLog('Deleted', where, `${where} o'chirildi`, {
        itemId: id,
      }).catch((err) => console.error('Log yozishda xato:', err));
    } catch (err) {
      console.log(`Error deleting ${collection}:`, err);
      setError(err);
    } finally {
      if (fetch) {
        fetch();
      }
      setLoading(false);
    }
  };

  return { deleteItem, loading, error };
};

export default useDelete;
